import { render, staticRenderFns } from "./IndexVideo.vue?vue&type=template&id=56282e07&"
import script from "./IndexVideo.vue?vue&type=script&lang=js&"
export * from "./IndexVideo.vue?vue&type=script&lang=js&"
import style0 from "./IndexVideo.vue?vue&type=style&index=0&id=56282e07&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports